// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"10":"72f39e0c","865":"fe328349"}[chunkId] + ".css";
};